import React from 'react';
import { Outlet } from 'react-router-dom';
import PWAInstallPrompt from '../PWAInstallPrompt';
import DynamicPlatformBranding from '../DynamicPlatformBranding';
import BloqueoDeSalida from '../BloqueoDeSalida';

// Con data router, lo que antes vivia dentro de <Router> pero fuera de <Routes>
// necesita una ruta sin path que lo albergue. PWAInstallPrompt usa hooks de router,
// asi que tiene que quedar aqui dentro.
const RootLayout = () => (
  <div className="App min-h-screen bg-black">
    <Outlet />
    <PWAInstallPrompt />
    <DynamicPlatformBranding />
    <BloqueoDeSalida />
  </div>
);

export default RootLayout;
